import { type BaseOptionType } from "antd/lib/select"

export const filterOptionsByVisibility = (
  options: BaseOptionType[] | undefined,
  type: string
) => {
  if (!options || !Array.isArray(options)) {
    return []
  }

  return options.filter((option) => {
    if (!option?.["visible_in"]) {
      return true
    }

    if (!Array.isArray(option?.["visible_in"])) {
      return true
    }

    return option?.["visible_in"]?.includes(type)
  })
}
